const removeAccents = (s) => {
  let r = s.toLowerCase()
  r = r.replace(new RegExp('[àá]', 'g'), 'a')
  r = r.replace(new RegExp('[èé]', 'g'), 'e')
  r = r.replace(new RegExp('[ìí]', 'g'), 'i')
  r = r.replace(new RegExp('[òó]', 'g'), 'o')
  r = r.replace(new RegExp('[ùú]', 'g'), 'u')
  return r
}

const torSlugFromName = (torName, torPlace) =>
  removeAccents(
    `${torName.toLowerCase().replaceAll(' ', '-')}-${torPlace
      .toLowerCase()
      .replaceAll(' ', '-')}`
  )

const capitalize = (str) =>
  `${str.substr(0, 1).toUpperCase()}${str.substr(1).toLowerCase()}`

const capitalizeString = (str) =>
  str
    ?.split(' ')
    .map((word, idx) =>
      (idx === 0) & (word[1] === 'I') ? word : capitalize(word)
    )
    .join(' ')

const addDotsToNumbers = (data) =>
  data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')

const formatName = (fullName) => {
  if (!fullName) return ''

  const parts = fullName.trim().split(/[\s,]+/)
  const firstName = parts[0] || ''
  const lastName = parts[1] || ''

  return capitalizeString(`${firstName} ${lastName}`.trim())
}

const getLongTeamName = (team = {}) => {
  const nameTeam = team?.NameTeam ?? ''
  const sexTeam = team?.SexTeam ?? ''
  const grouperTournament = team?.GrouperTournament ?? ''

  const sexShort =
    typeof sexTeam === 'string' && sexTeam.length >= 3
      ? sexTeam.slice(0, 3)
      : sexTeam || ''

  return [nameTeam, sexShort, grouperTournament].filter(Boolean).join(' - ')
}

export {
  removeAccents,
  torSlugFromName,
  capitalize,
  capitalizeString,
  addDotsToNumbers,
  formatName,
  getLongTeamName
}
